interface NumberStatProps {
    title: string;
    value: number;
    icon: string;
    color: string;
}

export default function NumberStat(props: NumberStatProps) {
    return (
        <div className="w-[300px] h-fit flex flex-col border-2 rounded-xl pt-4 pb-1">
            <div className="flex gap-2 text-neutral-400 text-sm justify-center mb-[-16px]">
                <div><i className={props.icon}></i></div>
                <div>{props.title}</div>
            </div>
            <h1 className={`text-${props.color}-500 text-center`}>{props.value}</h1>
        </div>
    )
}